import React from 'react';
import './ApplePayInfo.css';

export const ApplePayInfo = ({ applePayID }) => {
  return (
    <div className="applePayInfo" data-heap-redact-text>
      <img
        className="applePayThumb"
        src="/account/static/images/cards/applepay-logo.svg"
        width="44"
        height="20"
        alt="ApplePay"
      />
      <span className="applePayId">{applePayID}</span>
    </div>
  );
};
